export default "data:font/ttf;base64,"